import React from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Widget from '../components/Widget';
import WidgetTrigger from '../components/WidgetTrigger';
import { ValidationService, ValidationShapers } from '../../services/ValidationService';
import * as WidgetReducer from '../reducers/widgetReducer';

class WidgetContainer extends React.Component {
  static initialState = {
    firstName: '',
    lastName: '',
    phone: '',
    question: '',
    showWidget: false,
    errors: {},
    response: null,
    isValidCaptcha: true,
    errorMessage: '',
    loading: false,
  }

  state = {
    ...WidgetContainer.initialState,
    showWidget: this.props.config.embedForm.hideCTAButton,
  };

  componentDidMount() {
    window.addEventListener('message', () => {
      this.postMessage();
    });
    this.postMessage();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      response: nextProps.response,
      isValidCaptcha: nextProps.isValidCaptcha,
      errorMessage: nextProps.errorMessage,
      loading: nextProps.loading,
    });
  }

  componentDidUpdate() {
    this.postMessage();
  }

  get payload() {
    const {
      firstName,
      lastName,
      question,
      phone,
    } = this.state;

    return {
      firstName,
      lastName,
      question,
      phone,
    };
  }

  getWidgetData = () => {
    const { showWidget } = this.state;
    const { config } = this.props;

    const data = {
      position: config.embedForm.position,
    };

    const widgetTrigger = ReactDOM.findDOMNode(this.widgetTrigger);
    const widgetContent = ReactDOM.findDOMNode(this.widgetContent);

    if (showWidget) {
      data.width = widgetContent.offsetWidth;
      data.height = widgetContent.offsetHeight;
    } else {
      data.width = widgetTrigger.offsetWidth;
      data.height = widgetTrigger.offsetHeight;
    }

    return data;
  }

  postMessage = () => {
    window.parent.postMessage({ rhinogram: this.getWidgetData() }, '*');
  }

  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  }

  handleToggle = () => {
    this.props.clearWidgetState();
    const { showWidget } = this.state;

    this.setState({
      ...WidgetContainer.initialState,
      showWidget: !showWidget,
    });
  }

  handleResetForm = () => {
    this.props.clearWidgetState();
    this.setState({
      ...WidgetContainer.initialState,
      showWidget: true,
    });
  }

  shapeWidgetForDB = (data, token) => ({
    firstName: data.firstName,
    lastName: data.lastName,
    channelId: this.props.channelId,
    organizationId: this.props.organizationId,
    phone: data.phone,
    text: data.question,
    reCaptchaToken: token,
  });

  handleSubmit = () => {
    const reCaptchaToken = window.grecaptcha.getResponse();
    const errors = ValidationService(ValidationShapers.shapeWebWidget(this.payload, reCaptchaToken));
    const errorCount = Object.keys(errors).length;

    if (errorCount > 0) {
      this.setState({ errors });
    } else {
      this.setState({
        errors: {},
      });
      const widgetMessage = this.shapeWidgetForDB(this.state, reCaptchaToken);
      this.props.createWidgetMessage(widgetMessage);
    }
  }

  render() {
    const {
      config,
    } = this.props;

    const {
      showWidget,
      firstName,
      lastName,
      phone,
      question,
      errors,
      response,
      isValidCaptcha,
      errorMessage,
      loading,
    } = this.state;

    const widgetTrigger = (trigger) => { this.widgetTrigger = trigger; };
    const widgetContent = (content) => { this.widgetContent = content; };

    const widgetWrapperClasses = cx({ widget__wrapper: showWidget });

    return (
      <div className={widgetWrapperClasses}>
        {showWidget ? (
          <Widget
            config={config}
            onCloseClick={this.handleToggle}
            onSubmitClick={this.handleSubmit}
            handleChange={this.handleChange}
            firstName={firstName}
            lastName={lastName}
            phone={phone}
            question={question}
            errors={errors}
            response={response}
            errorMessage={errorMessage}
            isValidCaptcha={isValidCaptcha}
            handleResetForm={this.handleResetForm}
            widgetContentRef={widgetContent}
            loading={loading}
            embed
          />
        ) : (
          <WidgetTrigger
            config={config}
            onClick={this.handleToggle}
            triggerRef={widgetTrigger}
          />
        )}
      </div>
    );
  }
}

WidgetContainer.propTypes = {
  config: PropTypes.object,
  createWidgetMessage: PropTypes.func.isRequired,
  clearWidgetState: PropTypes.func.isRequired,
  response: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  isValidCaptcha: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  errorMessage: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  loading: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  organizationId: PropTypes.number,
  channelId: PropTypes.number,
};

const mapStateToProps = (state) => {
  const { widget } = state;
  return {
    response: widget.response,
    isValidCaptcha: widget.isValidCaptcha,
    errorMessage: widget.errorMessage,
    loading: widget.loading,
    config: widget.config,
    organizationId: widget.orgId,
    channelId: widget.channelId,
  };
};

const actions = {
  createWidgetMessage: WidgetReducer.createWidgetMessage,
  clearWidgetState: WidgetReducer.clearWidgetState,
};

export default connect(mapStateToProps, actions)(WidgetContainer);
